<template>
    <a :href="'mailto:'+email_ccpa">{{email_ccpa}}</a>
</template>

<script>
import axios from "axios";

export default {
    data() {
        return {
            email_ccpa:''
        }
    },
    mounted() {
        axios.get(import.meta.env.VITE_API_GET_USER).then((response)=>{
            this.email_ccpa = response.data.email_ccpa;
        }).catch((error) => {
            console.error(error);
        });
    }
};
</script>
